export const GUEST_ROOM_EXPERIENCE_GLOBAL = 'guest_room_experience_global';
export const GUEST_ROOM_EXPERIENCE_TEMPLATE = 'guest_room_experience_template';
export const GUEST_ROOM_EXPERIENCE_ROOM = 'guest_room_experience_room';

export const GUEST_ROOM_EXPERIENCE_GLOBAL_TAB_DEFAULT = 'guest_room_experience_global_tab_default';
export const GUEST_ROOM_EXPERIENCE_GLOBAL_TAB_DND = 'guest_room_experience_global_tab_dnd';
export const GUEST_ROOM_EXPERIENCE_GLOBAL_TAB_MMR = 'guest_room_experience_global_tab_MMR';
export const GUEST_ROOM_EXPERIENCE_GLOBAL_TAB_DOOR_LOCK =
  'guest_room_experience_global_tab_door_lock';
export const GUEST_ROOM_EXPERIENCE_GLOBAL_DOOR_CAMERA =
  'guest_room_experience_global_tab_door_camera';

export const GUEST_ROOM_EXPERIENCE_ROOM_TAB_CREATE = 'guest_room_experience_room_tab_create';
export const GUEST_ROOM_EXPERIENCE_ROOM_TAB_EDIT = 'guest_room_experience_room_tab_edit';
export const GUEST_ROOM_EXPERIENCE_ROOM_TAB_VIEW = 'guest_room_experience_room_tab_view';
export const GUEST_ROOM_EXPERIENCE_ROOM_TAB_ROOM_AREA = 'guest_room_experience_room_tab_room-area';
export const GUEST_ROOM_EXPERIENCE_ROOM_TAB_DND = 'guest_room_experience_room_tab_dnd';
export const GUEST_ROOM_EXPERIENCE_ROOM_TAB_MMR = 'guest_room_experience_room_tab_mmr';
export const GUEST_ROOM_EXPERIENCE_ROOM_TAB_DIGITAL_DOOR_LOCK =
  'guest_room_experience_room_tab_digital_door_lock';
export const GUEST_ROOM_EXPERIENCE_ROOM_TAB_DOOR_CAMERA =
  'guest_room_experience_room_tab_door_camera';
export const GUEST_ROOM_EXPERIENCE_ROOM_TAB_DOOR_LOCK = 'guest_room_experience_room_tab_door_lock';

export const GUEST_ROOM_EXPERIENCE_ROOM_TAB_ROOM_AREA_LIGHT_EDIT =
  'guest_room_experience_room_tab_room-area_light_edit';
export const GUEST_ROOM_EXPERIENCE_ROOM_TAB_ROOM_AREA_THERMOSTAT_EDIT =
  'guest_room_experience_room_tab_room-area_thermostat_edit';
export const GUEST_ROOM_EXPERIENCE_ROOM_TAB_ROOM_AREA_CURTAIN_EDIT =
  'guest_room_experience_room_tab_room-area_curtain_edit';
export const GUEST_ROOM_EXPERIENCE_ROOM_TAB_ROOM_AREA_DOOR_LOCK_EDIT =
  'guest_room_experience_room_tab_room-area_door_lock_edit';
export const GUEST_ROOM_EXPERIENCE_ROOM_TAB_ROOM_AREA_SCENES_EDIT =
  'guest_room_experience_room_tab_room-area_scene_edit';
export const GUEST_ROOM_EXPERIENCE_ROOM_TAB_DOOR_LOCK_EDIT =
  'guest_room_experience_room_tab_door_lock_edit';

export const GUEST_ROOM_EXPERIENCE_ROOM_TAB_ROOM_AREA_LIGHT_DELETE =
  'guest_room_experience_room_tab_room-area_light_delete';
export const GUEST_ROOM_EXPERIENCE_ROOM_TAB_ROOM_AREA_THERMOSTAT_DELETE =
  'guest_room_experience_room_tab_room-area_thermostat_delete';
export const GUEST_ROOM_EXPERIENCE_ROOM_TAB_ROOM_AREA_CURTAIN_DELETE =
  'guest_room_experience_room_tab_room-area_curtain_delete';
export const GUEST_ROOM_EXPERIENCE_ROOM_TAB_ROOM_AREA_DOOR_LOCK_DELETE =
  'guest_room_experience_room_tab_room-area_door_lock_delete';
export const GUEST_ROOM_EXPERIENCE_ROOM_TAB_ROOM_AREA_SCENES_DELETE =
  'guest_room_experience_room_tab_room-area_scene_delete';
export const GUEST_ROOM_EXPERIENCE_ROOM_TAB_DOOR_LOCK_DELETE =
  'guest_room_experience_room_tab_door_lock_delete';

export const GUEST_ROOM_EXPERIENCE_TEMPLATE_CREATE = 'guest_room_experience_template_create';
export const GUEST_ROOM_EXPERIENCE_TEMPLATE_EDIT = 'guest_room_experience_template_edit';
export const GUEST_ROOM_EXPERIENCE_TEMPLATE_ADD_ROOM = 'guest_room_experience_template_add';
